var SENTRY_RELEASE;SENTRY_RELEASE={name: "Lift", version: "1.16.12"};